// Mock data for Kites Fly - The Travel Companion clone

export const HERO_IMAGE = "https://images.pexels.com/photos/12597037/pexels-photo-12597037.jpeg";

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "About us", href: "/about" },
  { label: "Holidays", href: "/holidays" },
  { label: "Services", href: "/services" },
  { label: "Contact us", href: "/contact" },
];

export const holidayPackages = [
  {
    id: 1,
    title: "Switzerland Tour Packages from India",
    duration: "6 Days 5 Nights",
    rating: 4.0,
    image: "/images/holidays/switzerland.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Guide", "Sightseeing"],
    highlights: ["Accommodation", "Breakfast", "Guided tour of Zurich & Lucerne", "Mount Titlis excursion"],
    price: 58000,
    oldPrice: 60900,
  },
  {
    id: 2,
    title: "Europe Multi Country Tour from India",
    duration: "12 Days 11 Nights",
    rating: 4.0,
    image: "/images/holidays/europe-multi-country.png",
    category: "International",
    features: ["Flight", "Guide", "Transfer", "Sightseeing"],
    highlights: ["International Flights", "Hotel Accommodation", "City tours in 5 countries", "Airport transfers"],
    price: 218000,
    oldPrice: 228000,
  },
  {
    id: 3,
    title: "Phuket and Krabi Tour Packages",
    duration: "5 Days 4 Nights",
    rating: 4.0,
    image: "/images/holidays/phuket-krabi.jpg",
    category: "International",
    features: ["Accommodation", "Daily breakfast", "Private airport", "Sightseeing"],
    highlights: ["2 Nights' accommodation in Phuket (3 star hotel)", "2 Nights' accommodation in Krabi (3star hotel)", "Phi Phi island tour"],
    price: 25500,
    oldPrice: 27500,
  },
  {
    id: 4,
    title: "Japan Tour Package",
    duration: "8 Days 7 Nights",
    rating: 4.0,
    image: "/images/holidays/japan.png",
    category: "International",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["3 Nights in Tokyo", "Narita Airport to Tokyo (One-Way Shared Transfer)", "Mt. Fuji day trip"],
    price: 160600,
    oldPrice: 165000,
  },
  {
    id: 5,
    title: "New Zealand Tour Package",
    duration: "15 Days 14 Nights",
    rating: 4.0,
    image: "/images/holidays/new-zealand.png",
    category: "International",
    features: ["Hotel", "Sightseeing", "Transfer"],
    highlights: ["Hotel Accommodation", "Transfers & Sightseeing", "Milford Sound Cruise"],
    price: 360000,
    oldPrice: 385000,
  },
  {
    id: 6,
    title: "Dubai City Explorer",
    duration: "4 Days 3 Nights",
    rating: 4.5,
    image: "/images/holidays/dubai-city-explorer.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Desert Safari", "Transfer"],
    highlights: ["Burj Khalifa entry", "Desert Safari with BBQ", "Dhow Cruise Dinner"],
    price: 45000,
    oldPrice: 52000,
  },
  {
    id: 7,
    title: "Bali Beach Retreat",
    duration: "6 Days 5 Nights",
    rating: 4.6,
    image: "/images/holidays/bali-beach-retreat.jpg",
    category: "International",
    features: ["Villa", "Breakfast", "Spa", "Sightseeing"],
    highlights: ["Private pool villa", "Ubud cultural tour", "Uluwatu sunset"],
    price: 42000,
    oldPrice: 48000,
  },
  {
    id: 8,
    title: "Maldives Honeymoon Special",
    duration: "5 Days 4 Nights",
    rating: 4.8,
    image: "/images/holidays/maldives-honeymoon.jpg",
    category: "International",
    features: ["Overwater villa", "All meals", "Speedboat", "Snorkeling"],
    highlights: ["Overwater bungalow stay", "Sunset cruise", "Private candlelight dinner"],
    price: 125000,
    oldPrice: 140000,
  },

  // ---------- DOMESTIC ----------
  {
    id: 101,
    title: "Delhi Agra Tour Package",
    duration: "3 Days 2 Nights",
    rating: 4.2,
    image: "/images/holidays/delhi-agra.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Transfer"],
    highlights: ["Red Fort & Qutub Minar sightseeing", "Sunrise visit to the Taj Mahal", "Agra Fort guided tour"],
    price: 16500,
    oldPrice: 18500,
  },
  {
    id: 102,
    title: "Hyderabad City Tour Package",
    duration: "3 Days 2 Nights",
    rating: 4.1,
    image: "/images/holidays/hyderabad.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Charminar & Golconda Fort", "Ramoji Film City option", "Hyderabadi biryani food trail"],
    price: 15000,
    oldPrice: 17000,
  },
  {
    id: 103,
    title: "Goa Beach Holiday Package",
    duration: "4 Days 3 Nights",
    rating: 4.3,
    image: "/images/holidays/goa-beach.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Water Sports", "Transfer"],
    highlights: ["North & South Goa beach tour", "Water sports at Baga Beach", "Old Goa churches heritage walk"],
    price: 14500,
    oldPrice: 16500,
  },
  {
    id: 104,
    title: "Jaipur Agra Delhi Golden Triangle",
    duration: "5 Days 4 Nights",
    rating: 4.4,
    image: "/images/holidays/golden-triangle.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Sightseeing"],
    highlights: ["Amber Fort & Hawa Mahal, Jaipur", "Taj Mahal & Agra Fort", "Delhi city & Qutub Minar tour"],
    price: 22000,
    oldPrice: 25000,
  },
  {
    id: 105,
    title: "Manali Kullu Valley Package",
    duration: "5 Days 4 Nights",
    rating: 4.4,
    image: "/images/holidays/manali-kullu.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Solang Valley & Rohtang Pass", "Kullu river rafting option", "Hadimba Temple & Old Manali"],
    price: 19500,
    oldPrice: 22000,
  },
  {
    id: 106,
    title: "Amritsar Agra Delhi Package",
    duration: "6 Days 5 Nights",
    rating: 4.3,
    image: "/images/holidays/amritsar-agra-delhi.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Transfer"],
    highlights: ["Golden Temple & Wagah Border ceremony", "Taj Mahal sunrise visit", "Delhi sightseeing & shopping"],
    price: 24500,
    oldPrice: 27500,
  },
  {
    id: 107,
    title: "Kashmir Paradise Tour",
    duration: "6 Days 5 Nights",
    rating: 4.6,
    image: "/images/holidays/kashmir.png",
    category: "Domestic",
    features: ["Houseboat", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Srinagar Dal Lake houseboat stay", "Gulmarg gondola ride", "Pahalgam & Sonmarg valleys"],
    price: 32000,
    oldPrice: 36000,
  },
  {
    id: 108,
    title: "Ayodhya Varanasi Prayagraj Yatra",
    duration: "4 Days 3 Nights",
    rating: 4.5,
    image: "/images/holidays/ayodhya-varanasi-prayagraj.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Transfer"],
    highlights: ["Ram Mandir darshan, Ayodhya", "Ganga Aarti at Varanasi ghats", "Triveni Sangam, Prayagraj"],
    price: 18000,
    oldPrice: 20500,
  },
  {
    id: 109,
    title: "Rajasthan Royal Tour Package",
    duration: "7 Days 6 Nights",
    rating: 4.5,
    image: "/images/holidays/rajasthan-royal.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Sightseeing"],
    highlights: ["Jaipur City Palace & Amber Fort", "Udaipur lakes & Jodhpur's Mehrangarh", "Jaisalmer desert camel safari"],
    price: 34000,
    oldPrice: 38500,
  },
  {
    id: 110,
    title: "Ajanta Ellora Caves Tour",
    duration: "3 Days 2 Nights",
    rating: 4.2,
    image: "/images/holidays/ajanta-ellora.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Transfer"],
    highlights: ["UNESCO Ajanta rock-cut caves", "Ellora's Kailasa Temple", "Aurangabad heritage sightseeing"],
    price: 16000,
    oldPrice: 18000,
  },
  {
    id: 111,
    title: "Agumbe Rainforest Retreat",
    duration: "3 Days 2 Nights",
    rating: 4.3,
    image: "/images/holidays/agumbe-rainforest.png",
    category: "Domestic",
    features: ["Homestay", "Breakfast", "Trekking", "Transfer"],
    highlights: ["Sunset Point views over the Western Ghats", "Rainforest nature trek", "Barkana & Onake Abbi waterfalls"],
    price: 13500,
    oldPrice: 15500,
  },
  {
    id: 112,
    title: "Matheran Hill Station Getaway",
    duration: "2 Days 1 Night",
    rating: 4.1,
    image: "/images/holidays/matheran.jpg",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Sightseeing"],
    highlights: ["Vehicle-free hill station walks", "Charlotte Lake & One Tree Hill", "Toy train ride option"],
    price: 8500,
    oldPrice: 9800,
  },
  {
    id: 113,
    title: "Lakshadweep Island Escape",
    duration: "5 Days 4 Nights",
    rating: 4.7,
    image: "/images/holidays/lakshadweep.png",
    category: "Domestic",
    features: ["Resort", "All meals", "Snorkeling", "Ferry"],
    highlights: ["Turquoise lagoon islands", "Snorkeling & kayaking", "Bangaram / Kavaratti island stay"],
    price: 42000,
    oldPrice: 47000,
  },
  {
    id: 114,
    title: "Karnataka Heritage Hampi Tour",
    duration: "4 Days 3 Nights",
    rating: 4.4,
    image: "/images/holidays/hampi-karnataka.jpg",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Sightseeing"],
    highlights: ["Hampi's UNESCO ruins", "Badami & Pattadakal cave temples", "Tungabhadra coracle ride"],
    price: 19500,
    oldPrice: 22500,
  },
  {
    id: 115,
    title: "Tamil Nadu Heritage & Pondicherry",
    duration: "4 Days 3 Nights",
    rating: 4.3,
    image: "/images/holidays/tamil-nadu-pondicherry.png",
    category: "Domestic",
    features: ["Hotel", "Breakfast", "Guide", "Transfer"],
    highlights: ["French Quarter, Pondicherry", "Mahabalipuram shore temples", "Auroville & Promenade Beach"],
    price: 18500,
    oldPrice: 21000,
  },

  // ---------- INTERNATIONAL (additional) ----------
  {
    id: 201,
    title: "Malaysia Tour Package",
    duration: "5 Days 4 Nights",
    rating: 4.3,
    image: "/images/holidays/malaysia.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Petronas Twin Towers & KL city tour", "Genting Highlands cable car", "Langkawi island add-on"],
    price: 55000,
    oldPrice: 60000,
  },
  {
    id: 202,
    title: "Thailand Bangkok Pattaya Package",
    duration: "5 Days 4 Nights",
    rating: 4.2,
    image: "/images/holidays/thailand-bangkok-pattaya.png",
    category: "International",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Coral Island tour, Pattaya", "Bangkok city & temple tour", "Alcazar cabaret show option"],
    price: 38000,
    oldPrice: 43000,
  },
  {
    id: 203,
    title: "Dubai Abu Dhabi Combo Package",
    duration: "5 Days 4 Nights",
    rating: 4.5,
    image: "/images/holidays/dubai-abu-dhabi.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Desert Safari", "Transfer"],
    highlights: ["Burj Khalifa At the Top", "Sheikh Zayed Grand Mosque, Abu Dhabi", "Desert safari with BBQ dinner"],
    price: 58000,
    oldPrice: 64000,
  },
  {
    id: 204,
    title: "Maldives Island Hopper Package",
    duration: "4 Days 3 Nights",
    rating: 4.7,
    image: "/images/holidays/maldives-island-hopper.png",
    category: "International",
    features: ["Resort", "Breakfast", "Speedboat", "Snorkeling"],
    highlights: ["Multi-island beach stay", "Snorkeling at the house reef", "Sunset dolphin cruise"],
    price: 95000,
    oldPrice: 105000,
  },
  {
    id: 205,
    title: "Andaman Islands Tour Package",
    duration: "5 Days 4 Nights",
    rating: 4.5,
    image: "/images/holidays/andaman.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Ferry", "Snorkeling"],
    highlights: ["Radhanagar Beach, Havelock Island", "Cellular Jail light & sound show", "Scuba diving option"],
    price: 36000,
    oldPrice: 40000,
  },
  {
    id: 206,
    title: "Nepal Kathmandu Pokhara Package",
    duration: "5 Days 4 Nights",
    rating: 4.3,
    image: "/images/holidays/nepal.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Pashupatinath & Swayambhunath temples", "Phewa Lake boating, Pokhara", "Sarangkot sunrise view"],
    price: 32000,
    oldPrice: 36000,
  },
  {
    id: 207,
    title: "Bhutan Thimphu Paro Package",
    duration: "5 Days 4 Nights",
    rating: 4.6,
    image: "/images/holidays/bhutan.png",
    category: "International",
    features: ["Hotel", "Breakfast", "Permits", "Transfer"],
    highlights: ["Tiger's Nest Monastery hike", "Thimphu Dzong & local market", "Punakha Dzong day trip"],
    price: 45000,
    oldPrice: 50000,
  },
  {
    id: 208,
    title: "Bali Culture & Coast Package",
    duration: "5 Days 4 Nights",
    rating: 4.5,
    image: "/images/holidays/bali-culture-coast.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Tanah Lot sunset temple", "Kintamani volcano viewpoint", "Nusa Penida day trip option"],
    price: 44000,
    oldPrice: 49500,
  },
  {
    id: 209,
    title: "Vietnam Hanoi Ha Long Bay Package",
    duration: "6 Days 5 Nights",
    rating: 4.4,
    image: "/images/holidays/vietnam.png",
    category: "International",
    features: ["Hotel", "Breakfast", "Cruise", "Transfer"],
    highlights: ["Overnight Ha Long Bay cruise", "Hanoi Old Quarter walking tour", "Ho Chi Minh City extension option"],
    price: 62000,
    oldPrice: 68000,
  },
  {
    id: 210,
    title: "China Beijing Shanghai Package",
    duration: "7 Days 6 Nights",
    rating: 4.3,
    image: "/images/holidays/china.jpg",
    category: "International",
    features: ["Hotel", "Breakfast", "Guide", "Sightseeing"],
    highlights: ["Great Wall of China excursion", "Forbidden City & Tiananmen Square", "The Bund, Shanghai skyline"],
    price: 95000,
    oldPrice: 105000,
  },

  // ---------- ONE DAY FLY ----------
  {
    id: 301,
    title: "Kochi Quick Getaway",
    duration: "2 Days 1 Night",
    rating: 4.1,
    image: "/images/holidays/kochi-quick-getaway.png",
    category: "One Day Fly",
    features: ["Hotel", "Breakfast", "Transfer"],
    highlights: ["Fort Kochi heritage walk", "Backwater day cruise", "Chinese fishing nets at sunset"],
    price: 9500,
    oldPrice: 11000,
  },
  {
    id: 302,
    title: "Trivandrum Quick Getaway",
    duration: "2 Days 1 Night",
    rating: 4.0,
    image: "/images/holidays/trivandrum-quick-getaway.jpg",
    category: "One Day Fly",
    features: ["Hotel", "Breakfast", "Transfer"],
    highlights: ["Kovalam Lighthouse Beach", "Sree Padmanabhaswamy Temple", "Napier Museum visit"],
    price: 9000,
    oldPrice: 10500,
  },
  {
    id: 303,
    title: "Bangalore Quick Getaway",
    duration: "2 Days 1 Night",
    rating: 4.1,
    image: "/images/holidays/bangalore-quick-getaway.png",
    category: "One Day Fly",
    features: ["Hotel", "Breakfast", "Transfer"],
    highlights: ["Nandi Hills sunrise trip", "Lalbagh Botanical Garden", "MG Road city tour"],
    price: 8500,
    oldPrice: 10000,
  },

  // ---------- TWO DAY FLY ----------
  {
    id: 401,
    title: "Kochi Alappuzha Backwater Package",
    duration: "3 Days 2 Nights",
    rating: 4.4,
    image: "/images/holidays/kochi-alappuzha-backwaters.jpg",
    category: "Two Day Fly",
    features: ["Houseboat", "All meals", "Transfer"],
    highlights: ["Overnight Alleppey houseboat stay", "Fort Kochi sightseeing", "Village canal canoe ride"],
    price: 13500,
    oldPrice: 15500,
  },
  {
    id: 402,
    title: "Kochi Munnar Hills Package",
    duration: "3 Days 2 Nights",
    rating: 4.5,
    image: "/images/holidays/kochi-munnar.png",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Munnar tea garden trails", "Eravikulam National Park", "Fort Kochi city tour"],
    price: 14000,
    oldPrice: 16000,
  },
  {
    id: 403,
    title: "Trivandrum Varkala Package",
    duration: "3 Days 2 Nights",
    rating: 4.3,
    image: "/images/holidays/trivandrum-varkala.jpg",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Transfer"],
    highlights: ["Kovalam beach stay", "Varkala cliffside beach", "Padmanabhaswamy Temple visit"],
    price: 12500,
    oldPrice: 14500,
  },
  {
    id: 404,
    title: "Kanyakumari Package",
    duration: "3 Days 2 Nights",
    rating: 4.2,
    image: "/images/holidays/kanyakumari.png",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Vivekananda Rock Memorial ferry", "Sunrise-sunset point", "Thiruvalluvar Statue"],
    price: 12000,
    oldPrice: 14000,
  },
  {
    id: 405,
    title: "Kannur Wayanad Package",
    duration: "3 Days 2 Nights",
    rating: 4.4,
    image: "/images/holidays/kannur-wayanad.jpg",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Trekking", "Transfer"],
    highlights: ["Kannur beaches & Fort St. Angelo", "Wayanad wildlife sanctuary", "Edakkal Caves trek"],
    price: 13000,
    oldPrice: 15000,
  },
  {
    id: 406,
    title: "Bangalore Coorg Package",
    duration: "3 Days 2 Nights",
    rating: 4.3,
    image: "/images/holidays/bangalore-coorg.png",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Bangalore city highlights", "Coorg coffee plantation visit", "Abbey Falls"],
    price: 13500,
    oldPrice: 15500,
  },
  {
    id: 407,
    title: "Mysore Heritage Package",
    duration: "3 Days 2 Nights",
    rating: 4.4,
    image: "/images/holidays/mysore-heritage.png",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Guide", "Transfer"],
    highlights: ["Mysore Palace illumination", "Chamundi Hills temple", "Brindavan Gardens musical fountain"],
    price: 12500,
    oldPrice: 14500,
  },
  {
    id: 408,
    title: "Yercaud Hogenakkal Package",
    duration: "3 Days 2 Nights",
    rating: 4.2,
    image: "/images/holidays/yercaud-hogenakkal.jpg",
    category: "Two Day Fly",
    features: ["Hotel", "Breakfast", "Sightseeing", "Transfer"],
    highlights: ["Yercaud lake & viewpoints", "Hogenakkal waterfalls coracle ride", "Botanical garden walk"],
    price: 12000,
    oldPrice: 14000,
  },
];

export const holidayCategories = ["All", "Domestic", "International", "One Day Fly", "Two Day Fly"];

export const popularVisas = [
  { code: "US", name: "USA Visa", flag: "https://flagcdn.com/w640/us.png", track: "FAST TRACK", processing: "7-14 days" },
  { code: "CA", name: "Canada Visa", flag: "https://flagcdn.com/w640/ca.png", track: "FAST TRACK", processing: "10-15 days" },
  { code: "AU", name: "Australia Visa", flag: "https://flagcdn.com/w640/au.png", track: "FAST TRACK", processing: "12-20 days" },
  { code: "GB", name: "UK Visa", flag: "https://flagcdn.com/w640/gb.png", track: "FAST TRACK", processing: "10-15 days" },
  { code: "JP", name: "Japan Visa", flag: "https://flagcdn.com/w640/jp.png", track: "FAST TRACK", processing: "5-7 days" },
  { code: "SG", name: "Singapore Visa", flag: "https://flagcdn.com/w640/sg.png", track: "FAST TRACK", processing: "3-5 days" },
  { code: "AE", name: "UAE Visa", flag: "https://flagcdn.com/w640/ae.png", track: "FAST TRACK", processing: "3-5 days" },
  { code: "TH", name: "Thailand Visa", flag: "https://flagcdn.com/w640/th.png", track: "FAST TRACK", processing: "5-7 days" },
  { code: "CH", name: "Switzerland Visa", flag: "https://flagcdn.com/w640/ch.png", track: "FAST TRACK", processing: "10-15 days" },
  { code: "TR", name: "Turkey Visa", flag: "https://flagcdn.com/w640/tr.png", track: "FAST TRACK", processing: "3-5 days" },
];

export const testimonials = [
  {
    id: 1,
    name: "Sureshbabu Ut",
    initials: "SU",
    branch: "Kozhikode",
    ago: "a week ago",
    rating: 5,
    text: "❤️ This was my first group trip with Kites Fly. It was a well-organized and punctual trip. The food and accommodation were a perfect 10 out of 10. The accompanying guide was also excellent. 👍",
  },
  {
    id: 2,
    name: "PK Binil",
    initials: "PK",
    branch: "Kozhikode",
    ago: "a month ago",
    rating: 5,
    text: "Great experience with Kites Fly. Highly recommended for anyone looking for a smooth and well-planned travel experience.",
  },
  {
    id: 3,
    name: "sunilpoyil poyil",
    initials: "SP",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Super cordination....",
  },
  {
    id: 4,
    name: "Vinsha Akhil",
    initials: "VA",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Excellent 🤩🤩🤩🤩",
  },
  {
    id: 5,
    name: "Anusha Byjesh",
    initials: "AB",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Super service 👌🏻👌🏻",
  },
  {
    id: 6,
    name: "Sreejisha Sabinesh",
    initials: "SS",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Nice",
  },
  {
    id: 7,
    name: "prasannan pappinisseri",
    initials: "PP",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Wonderful experience with Kites Fly team. Professional service throughout the journey.",
  },
  {
    id: 8,
    name: "Ajeesh CV",
    initials: "AC",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Excellent",
  },
  {
    id: 9,
    name: "NANDU RZH",
    initials: "NR",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Good service",
  },
  {
    id: 10,
    name: "Thushu Aji",
    initials: "TA",
    branch: "Kozhikode",
    ago: "a year ago",
    rating: 5,
    text: "Very good",
  },
];

export const services = [
  { icon: "MapPin", title: "Tour Packages", desc: "Customised international & domestic tour packages tailored to your dream destinations." },
  { icon: "Landmark", title: "Pilgrim Packages", desc: "Curated spiritual journeys to sacred destinations with comfortable stays and guidance." },
  { icon: "BookUser", title: "Passport Services", desc: "End-to-end assistance for new passports, renewals, tatkal & document verification." },
  { icon: "Ticket", title: "Flight, Train & Bus Ticket Booking", desc: "One-stop booking for domestic & international flights, trains and bus tickets." },
  { icon: "FileCheck", title: "Visa Services", desc: "Hassle-free visa processing for 100+ countries with expert documentation support." },
  { icon: "Hotel", title: "Hotel Reservations", desc: "Handpicked stays from budget to luxury, in every corner of the globe." },
  { icon: "ShieldCheck", title: "Travel Insurance", desc: "Comprehensive travel insurance plans for peace of mind on every journey." },
];

export const stats = [
  { value: "2M+", label: "Travellers Served" },
  { value: "18+", label: "Years Of Experience" },
  { value: "100+", label: "Destinations Covered" },
  { value: "24/7", label: "Travel Assistance" },
];

export const popularDestinations = [
  {
    name: "Switzerland",
    image: "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Snow-capped peaks, alpine lakes and scenic train rides through the Swiss countryside.",
  },
  {
    name: "Dubai",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Futuristic skylines, desert safaris and luxury shopping in the heart of the UAE.",
  },
  {
    name: "Bali",
    image: "https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Lush rice terraces, sacred temples and laid-back beaches on the Island of the Gods.",
  },
  {
    name: "Maldives",
    image: "https://images.unsplash.com/photo-1586495985096-787fb4a54ac0?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Overwater villas and crystal-clear lagoons made for the perfect honeymoon escape.",
  },
  {
    name: "Japan",
    image: "https://images.unsplash.com/photo-1522547902298-51566e4fb383?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Ancient temples, cherry blossoms and vibrant cities blending tradition with tomorrow.",
  },
  {
    name: "New Zealand",
    image: "https://images.unsplash.com/photo-1465056836041-7f43ac27dcb5?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Dramatic fjords, rolling hills and adventure sports across two stunning islands.",
  },
];

export const destinations = [
  "Dubai", "Singapore", "Thailand", "Malaysia", "Bali", "Maldives",
  "Switzerland", "Paris", "Italy", "Turkey", "Japan", "USA",
];

export const domesticDestinations = [
  "Kashmir", "Ladakh", "Kerala", "Goa", "Rajasthan", "Himachal Pradesh",
  "Uttarakhand", "Andaman & Nicobar", "Sikkim", "Meghalaya", "Karnataka", "Tamil Nadu",
];

export const internationalDestinations = [
  "Dubai", "Singapore", "Thailand", "Malaysia", "Bali", "Maldives",
  "Switzerland", "Paris", "Italy", "Turkey", "Japan", "Saudi Arabia (Umrah)",
  "USA", "UK", "New Zealand", "Australia",
];
